import io from 'socket.io-client';

/**
 * Resolves target WebSocket server URL from environment variables
 */
const getSocketServerUrl = () => {
  return (
    process.env.REACT_APP_SOCKET_URL ||
    process.env.REACT_APP_SERVERURL ||
    'https://apis.nemtplatform.com'
  );
};

/**
 * Socket.IO client factory (v2.x compatible).
 * Configured with autoConnect: false to prevent unauthorized connection on app startup.
 */
export const createSocketClient = (customUrl = null, customOptions = {}) => {
  const targetUrl = customUrl || getSocketServerUrl();
  const socketFactory = typeof io === 'function' ? io : (io.default || io.io || io);

  return socketFactory(targetUrl, {
    autoConnect: false, // Do NOT connect automatically
    forceNew: true, // Force a new distinct connection instance
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
    transports: ['websocket', 'polling'],
    ...customOptions,
  });
};

export default createSocketClient;
